module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_500_Inactive@1x-b7175a8d9ebbc3600db1798e2e2e06d6.png";